import { extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.esm.js';
import { cn } from '@costar-ui/cosmos';
import { IconClose } from '@costar-ui/icons/csg/IconClose';
import React__default, { useCallback } from 'react';
import { defaultModalScrollBarId } from './default-modal-scroll-bar-id.esm.js';
import { chainWithBreakCondition } from '../../../utils/chain-with-break-condition.esm.js';
import Card from '../../card/card.esm.js';
import Heading from '../../text/heading.esm.js';
import { CARD_ICON_BTN_STND_PROPS } from '../../card/types.esm.js';
import Button from '../../button/button.esm.js';

var iconButtonProps = CARD_ICON_BTN_STND_PROPS.iconButtonProps,
  iconProps = CARD_ICON_BTN_STND_PROPS.iconProps;
function AlertDialogLayout(props) {
  var _props$title = props.title,
    title = _props$title === void 0 ? ' ' : _props$title,
    _props$slots = props.slots,
    slots = _props$slots === void 0 ? {} : _props$slots,
    showCloseIcon = props.showCloseIcon,
    hideFooter = props.hideFooter,
    cancelLabel = props.cancelLabel,
    actionSecondaryLabel = props.actionSecondaryLabel,
    actionLabel = props.actionLabel,
    onActionSecondary = props.onActionSecondary,
    onAction = props.onAction,
    onCancel = props.onCancel,
    onClose = props.onClose,
    actionDisabled = props.actionDisabled,
    actionSecondaryDisabled = props.actionSecondaryDisabled,
    cancelDisabled = props.cancelDisabled,
    closeDisabled = props.closeDisabled,
    children = props.children,
    hideFooterBorder = props.hideFooterBorder,
    _props$scrollBarId = props.scrollBarId,
    scrollBarId = _props$scrollBarId === void 0 ? defaultModalScrollBarId : _props$scrollBarId,
    hideHeaderBorder = props.hideHeaderBorder,
    _props$canShrink = props.canShrink,
    canShrink = _props$canShrink === void 0 ? true : _props$canShrink,
    _props$classNames = props.classNames,
    classNames = _props$classNames === void 0 ? {} : _props$classNames;
  var leftHeader = slots.leftHeader,
    rightHeader = slots.rightHeader,
    leftFooter = slots.leftFooter,
    rightFooter = slots.rightFooter;
  var _classNames$root = classNames.root,
    rootClassName = _classNames$root === void 0 ? '' : _classNames$root,
    _classNames$body = classNames.body,
    bodyClassName = _classNames$body === void 0 ? '' : _classNames$body,
    _classNames$header = classNames.header,
    headerClassName = _classNames$header === void 0 ? '' : _classNames$header,
    _classNames$footer = classNames.footer,
    footerClassName = _classNames$footer === void 0 ? '' : _classNames$footer,
    _classNames$leftFoote = classNames.leftFooterWrapper,
    leftFooterWrapperClassname = _classNames$leftFoote === void 0 ? '' : _classNames$leftFoote,
    _classNames$rightFoot = classNames.rightFooterWrapper,
    rightFooterWrapperClassName = _classNames$rightFoot === void 0 ? '' : _classNames$rightFoot;
  var handleClose = useCallback(function () {
    return onClose && onClose();
  }, [onClose]);
  var hasTitle = typeof title === 'string' ? !!title.trim() : !!title;
  var includeHeader = hasTitle || rightHeader || showCloseIcon;
  return /*#__PURE__*/React__default.createElement(Card, {
    fullWidth: true,
    direction: "vertical",
    bordered: false,
    className: cn(rootClassName),
    withDivider: false,
    canShrink: canShrink
  }, includeHeader ? /*#__PURE__*/React__default.createElement(Card.Header, {
    className: cn(headerClassName, {
      'px-8 py-4': !hideHeaderBorder,
      'px-8 pb-2 pt-4': !!hideHeaderBorder,
      'border border-b-neutral': !hideHeaderBorder
    })
  }, /*#__PURE__*/React__default.createElement(Card.Slot, {
    justify: "start",
    gap: "md"
  }, hasTitle ? /*#__PURE__*/React__default.createElement(Heading, {
    slot: "title",
    variant: "heading-18"
  }, title) : null, leftHeader), rightHeader || showCloseIcon ? /*#__PURE__*/React__default.createElement(Card.Slot, {
    justify: "end",
    gap: "md"
  }, rightHeader, showCloseIcon ? /*#__PURE__*/React__default.createElement(Button, _extends({}, iconButtonProps, {
    onPress: handleClose,
    isDisabled: closeDisabled
  }), /*#__PURE__*/React__default.createElement(IconClose, iconProps)) : null) : null) : null, /*#__PURE__*/React__default.createElement(Card.Body, {
    className: "p-8 ".concat(bodyClassName),
    canShrink: canShrink,
    scrollable: canShrink,
    id: scrollBarId
  }, children), !hideFooter && /*#__PURE__*/React__default.createElement(Card.Footer, {
    justify: !leftFooter ? 'end' : undefined,
    className: cn(footerClassName, {
      'px-8 py-4': !hideFooterBorder,
      'px-8 pb-4 pt-2': !!hideFooterBorder,
      'border border-t-neutral': !hideFooterBorder
    })
  }, leftFooter ? /*#__PURE__*/React__default.createElement(Card.Slot, {
    justify: "start",
    gap: "md",
    className: leftFooterWrapperClassname
  }, leftFooter) : null, /*#__PURE__*/React__default.createElement(Card.Slot, {
    justify: "end",
    gap: "lg",
    className: rightFooterWrapperClassName
  }, rightFooter, onCancel ? /*#__PURE__*/React__default.createElement(Button, {
    variant: "secondary",
    onPress: chainWithBreakCondition(onCancel, handleClose),
    isDisabled: cancelDisabled
  }, cancelLabel || 'Cancel') : null, onActionSecondary ? /*#__PURE__*/React__default.createElement(Button, {
    variant: "secondary",
    onPress: chainWithBreakCondition(onActionSecondary, handleClose),
    isDisabled: actionSecondaryDisabled
  }, actionSecondaryLabel || 'Button') : null, onAction ? /*#__PURE__*/React__default.createElement(Button, {
    variant: 'primary',
    autoFocus: true,
    onPress: chainWithBreakCondition(onAction, handleClose),
    isDisabled: actionDisabled
  }, actionLabel || 'OK') : null)));
}

export { AlertDialogLayout as default };
//# sourceMappingURL=alert-dialog.esm.js.map
